<template lang="">
    <v-card>
        
        <s-crud
            :config="config"
            title="Producción Aceite de Palta"
            :filter="filter"
            search-input
            add
            edit
            load
            remove
            @save="save($event)"
            @rowSelected="rowSelected($event)"
            @load="saveDemo(item)"
            ref="scrudAvocadoOil"
        >
            <template v-slot="props">
                <v-container>
                    <v-row>
                        <v-col class="s-col-form" sm="6" md="6">
                            <s-select
                                :items="itemsNumberGuide"
                                item-value="RcfID"
                                full
                                autocomplete
                                item-text="RcfNumberHarvestGuide"
                                label="Seleccione Nro. Guia de cosecha"
                                v-model="props.item.RcfID"
                                @input="inputNumberGuide($event, props.item)"
                                :slotTmp="true"
                            >
                                <template v-slot:item="data">
                                    {{ data.item.RcfNumberHarvestGuide }}
                                    <v-chip
                                        x-small
                                        style="margin-left: 5px"
                                        :color="
                                            data.item.inProcessTerminated > 0
                                                ? 'info'
                                                : data.item.inProcess > 0
                                                ? 'warning'
                                                : 'error'
                                        "
                                        >{{
                                            data.item.inProcessTerminated > 0
                                                ? 'Pesado: ' + data.item.TypeDoorName
                                                : data.item.inProcess > 0
                                                ? 'En Proceso: ' + data.item.TypeDoorName
                                                : 'Sin Pesar'
                                        }}</v-chip
                                    >
                                </template>
                            </s-select>
                        </v-col>
                        <!-- <v-col class="s-col-form" sm="3" md="3">
                            <s-text
                                label="Yuliano*"
                                v-model="props.item.AolYuliano"
                            />
                        </v-col> -->
                        <v-col class="s-col-form" sm="3" md="3">
                            <s-text
                                type="number"
                                label="Peso*"
                                v-model="props.item.AolWeight"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </s-crud>
    </v-card>

</template>

<script>

import FrzAvocadoOilService from '@/services/FrozenProduction/FrzAvocadoOilService';
import _sWeighedByBatch from "@/services/FreshProduction/WeighedByBatchService";

export default {
    components: {
        
    },
    data() {
        return {
            filter: {},
            item: {},
            lotReception: {
                RcfID: null,
                TypeEntryDocument: null,
                Serie: "",
                Issue: "",
                RcfWeightGuide: 0,
                RfsWeigth: 0,
                RfsWeightDiscart: 0,
                discart: 0,
                AolWeight: 0,
            },
            weightOthers: {
                WeightOne: 0,
                WeightTwo: 0,
            },
            ObjTypeEntryDocument: {},
            ObjTypeEntryDocumentA: [],
            TypeWeightGeneral: 0,
            itemsTypeWeight: [],
            itemsNumberGuide: [],
            viewItemsAll: {},
            typeChargeName: "",
            ship: 2,
            config: {
                service: FrzAvocadoOilService,
                model: {
                    AolID: "ID",
                    RcfID: null,
                    AolYuliano: "",
                    AolWeight: 0,
                    AsgAction: "",
                },
                headers: [
                    { text: "ID", value: "AolID" },
                    { text: "Guia Cosecha", value: "RcfID" },
                    { text: "Yuliano", value: "AolYuliano" },
                    { text: "Peso", value: "AolWeight" },
                    { text: "Estado", value: "SecStatusName" },
                    { text: "Acción", value: "AsgAction" },
                ]
            }
        }
    },
    mounted() {
        this.getHarvestGuide();
    },
    methods: {
        rowSelected(item) {
            if (item !== null) {
                this.item = item[0];
            } else {
                this.item = {};
            }
        },
        save(item){
            console.log("grabando", item)
            item.save();
        },
        getHarvestGuide() {
            _sWeighedByBatch
                .getHarvestGuide(
                    { xPrint: 0, TypeShip: this.ship },
                    this.$fun.getUserID(),
                )
                .then(r => {
                    this.itemsNumberGuide = r.data;
                });
        },
        inputNumberGuide(val, item) {
            if (val) {
                const guide = this.itemsNumberGuide.find(x => x.RcfID === val);

                console.log('datos que me vienen con el numero de guia', guide);
                if (guide) {
                    item.RcfID = guide.RcfID;
                    this.viewItemsAll = guide;
                    this.typeChargeName = guide.TypeChargeName;
                    item.AolYuliano = guide.PrfYuliano;
                }
            }
        },

        saveDemo(item) {
            if (!this.item.RcfID) {
                this.$fun.alert("Seleccione un registro", "warning");
                return;
            }

            this.lotReception = { ...this.item };

            this.$fun.alert("¿Seguro de subir a SAP?", "question")
                .then(r => {
                    if (r.value) {

                        if (this.lotReception.Serie == "" || this.lotReception.Serie == 0) {
                            this.$fun.alert("Ingrese Serie");
                            return;
                        }
                        if (this.lotReception.Issue == "" || this.lotReception.Issue == 0) {
                            this.$fun.alert("Ingrese número");
                            return;
                        }

                        this.lotReception.RfsWeigth = parseFloat(this.lotReception.RfsWeigth);

                        this.lotReception.TypeDocument = this.ObjTypeEntryDocument.DedValue;

                        console.log("this.lotReception.WbbNetWeight", this.$fun.getUserSAPInfo().UsrID, this.lotReception)

                        FrzAvocadoOilService.loadsapDemoAvocadoOil(this.lotReception, this.$fun.getUserSAPInfo().UsrID, this.$fun.getUserID()).then(resp => {
                            if (resp.status == 200) {
                                this.$fun.alert("Subido Correctamente", "success")
                            }
                        })
                    }
                })
        }
    }
}

</script>